import {
  Breadcrumb,
  Col,
  Flex,
  Form,
  List,
  MenuProps,
  message,
  Row,
  Skeleton,
  Spin,
  Switch,
  Tabs,
  TabsProps,
} from "antd";
import BasicInfo from "../../components/teamMember/BasicInfo";
import { css } from "@emotion/css";
import { useLocation, useNavigate } from "react-router-dom";
import ClockSVG from "../../assets/teamMember/ClockSVG";
import LocationInfo from "../../components/teamMember/location/LocationInfo";
import { queryKeys } from "../../services/react-query/queryKeys";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  showTeamMember,
  updateTeamMemberActiveStatus,
} from "../../network/teamMember";
import ServiceInfo from "../../components/teamMember/service/ServiceInfo";
import WorkingHours from "../../components/teamMember/WorkingHours";
import Commissions from "../../components/teamMember/commission/Commissions";
import Permission from "../../components/teamMember/permission/Permission";
import QuickActionButton from "../../components/common/QuickActionButton";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import TeamMemberImg from "../../components/teamMember/teamMemberImg/TeamMemberImg";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
export default function TeamMemberData() {
  const intl = useIntl();
  const navigate = useNavigate();
  const TabStyles = css`
    @media (min-width: 1025px) {
      .ant-tabs-rtl .ant-tabs-nav .ant-tabs-tab {
        width: 160px;
      }
    }
  `;
  const { locationId, currentLang } = useSelector(
    (state: {
      calendar: { locationId: number };
      user: { currentLang: "en" | "ar" };
    }) => {
      return {
        locationId: state.calendar?.locationId,
        currentLang: state.user.currentLang,
      };
    }
  );
  const items: MenuProps["items"] = [
    {
      label: "1st menu item",
      key: "1",
    },
    {
      label: "2nd menu item",
      key: "2",
    },
  ];
  const location = useLocation();

  const data = location.state.team_member_data;

  const {
    data: listSpecificTeamMember,
    isLoading,
    refetch,
  } = useQuery([queryKeys.listSpacficTeamMemer, data.id], () =>
    showTeamMember(data.id, true)
  );
  const { mutate, isLoading: isStatusLoading } = useMutation(
    (status: boolean) => {
      if (!listSpecificTeamMember?.data?.id) {
        return;
      }

      return updateTeamMemberActiveStatus({
        value: status,
        team_members: [listSpecificTeamMember?.data?.id],
      });
    },
    {
      onSuccess: (res: any) => {
        console.log(res);
        if (res?.code !== "ERR_BAD_REQUEST") {
          refetch();
          message.success(
            intl.formatMessage({
              id: "statusUpdatedSuccessfully",
              defaultMessage: "تم تحديث الحالة بنجاح",
            })
          );
        } else {
          message.error(res?.response?.data?.message);
        }
      },
    }
  );
  const onChangeSwitch = (e: boolean) => {
    mutate(e);
  };

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: intl.formatMessage({
        id: "basicInfo",
        defaultMessage: "المعلومات الأساسية",
      }),
      children: isLoading ? null : (
        <BasicInfo
          editMode={data?.editMode || false}
          teamMemberData={listSpecificTeamMember?.data}
        />
      ),
    },
    {
      key: "2",
      label: intl.formatMessage({
        id: "Branches",
        defaultMessage: "الفروع",
      }),
      children: isLoading ? null : (
        <LocationInfo teamMemberData={listSpecificTeamMember?.data} />
      ),
    },
    {
      key: "3",
      label: intl.formatMessage({
        id: "servicesAndPAckages",
        defaultMessage: "الخدمات  والباقات المقدمة",
      }),
      children: isLoading ? null : (
        <ServiceInfo teamMemberData={listSpecificTeamMember?.data} />
      ),
    },
    {
      key: "4",
      label: intl.formatMessage({
        id: "workingHours",
        defaultMessage: "اوقات العمل",
      }),
      children: isLoading ? null : (
        <WorkingHours
          locationId={locationId}
          teamMemberData={listSpecificTeamMember?.data}
        />
      ),
    },
    {
      key: "5",
      label: intl.formatMessage({
        id: "permissions",
        defaultMessage: "الصلاحيات",
      }),
      children: isLoading ? null : (
        <Permission teamMemberData={listSpecificTeamMember?.data} />
      ),
    },
    {
      key: "6",
      label: intl.formatMessage({
        id: "commission",
        defaultMessage: "العمولة",
      }),
      children: isLoading ? null : (
        <Commissions teamMemberData={listSpecificTeamMember?.data} />
      ),
    },
  ];
  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-full min-h-screen ">
        <Spin size="large" />
      </div>
    );
  }
  return (
    <Flex vertical className="mt-5 p-7">
      <Row className="w-full mb-4" justify={"space-between"}>
        <Col className="text-color-primary text-2xl font-semibold leading-7">
          <Breadcrumb
            separator=">"
            items={[
              {
                title: intl.formatMessage({
                  id: "Settings",
                  defaultMessage: "الإعدادات",
                }),
                href: "#",
                onClick: () => {
                  navigate("/settings");
                },
              },
              {
                title: intl.formatMessage({
                  id: "teamMembers",
                  defaultMessage: "فريق العمل",
                }),
                href: "#",
                onClick: () => {
                  navigate("/team-members");
                },
              },
              {
                title: listSpecificTeamMember?.data?.name[currentLang] || "",
                href: "#",
                onClick: () => {
                  navigate("/team-members");
                },
              },
            ]}
          />
        </Col>
        <Col>
          <QuickActionButton />
        </Col>
      </Row>
      <Row>
        <SalonLocationsSelect
          activeLocations={listSpecificTeamMember?.data?.locations?.map(
            (location: any) => location.id
          )}
        />
      </Row>

      <List
        grid={{
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 5,
          xxl: 1,
        }}
        className="mt-4 "
      >
        <List.Item className="">
          <div className="flex flex-col gap-2 md:flex-row-reverse justify-between">
            <Form.Item
              className=""
              name="calendar_booking"
              rules={[{ required: true, message: "صفقة جديدة مطلوب" }]}
              initialValue={
                listSpecificTeamMember?.data?.calendar_booking === 1
                  ? true
                  : false
              }
              valuePropName="checked"
            >
              <Switch
                disabled={isStatusLoading}
                defaultChecked={
                  listSpecificTeamMember?.data?.calendar_booking === 1
                    ? true
                    : false
                }
                className="custom-switch-text"
                onChange={onChangeSwitch}
                checkedChildren={
                  <span style={{ color: "#00086D" }}>
                    {intl.formatMessage({
                      id: "bookingWithTeamMemeberEnabled",
                      defaultMessage: "الحجز مع العضو مفعل",
                    })}
                  </span>
                }
                unCheckedChildren={
                  <span style={{ color: "gray" }}>
                    {" "}
                    {intl.formatMessage({
                      id: "bookingWithTeamMemeberDisabled",
                      defaultMessage: "الحجز مع العضو غير مفعل",
                    })}
                  </span>
                }
              />
            </Form.Item>

            <List.Item.Meta
              className="space-y-2 flex flex-row gap-2 min-w-[330px] "
              avatar={
                <div>
                  {listSpecificTeamMember?.data ? (
                    <TeamMemberImg
                      mediaUrl={listSpecificTeamMember?.data?.media}
                      teamMemberId={listSpecificTeamMember?.data?.id}
                    />
                  ) : (
                    <Skeleton.Image
                      active
                      style={{ borderRadius: "50%" }}
                      className="w-[131px] h-[131px] rounded-full"
                    />
                  )}
                </div>
              }
              title={
                <div className="text-lg mt-5">
                  {listSpecificTeamMember?.data?.name[currentLang] || ""}
                </div>
              }
              description={
                <div className="text-color-gray text-sm font-normal leading-7">
                  <ClockSVG />{" "}
                  {intl.formatMessage({
                    id: "startedDate",
                    defaultMessage: "تاريخ البدء",
                  })}
                  : {listSpecificTeamMember?.data?.start_date}
                </div>
              }
            />
          </div>
        </List.Item>
      </List>
      <div className=" tabs-card-wrapper mt-8  ">
        <Tabs
          defaultActiveKey="1"
          items={itemsTab}
          tabBarStyle={{ margin: 0 }}
          type="card"
          className="shadow-md rounded"
        />
      </div>
    </Flex>
  );
}
